import { z } from "zod";

export const transkodierenRanges = ["0-10", "0-20", "0-100", "20-100", "100-1000", "1000-1000000"] as const;
const rangeSchema = z.enum(transkodierenRanges);
const difficultySchema = z.enum(["einfach", "normal", "schwer"]);
const countSchema = z.union([z.literal(5), z.literal(10), z.literal(15), z.literal(20)]);
const durationSchema = z.union([z.literal(180), z.literal(300), z.literal(600)]);

export const transkodierenExerciseConfigSchema = z.object({
  instructions: z.string().trim().min(1).max(2000).default("Lies das Zahlwort und gib die passende Zahl an."),
  defaultRange: rangeSchema.default("0-100"),
  defaultDifficulty: difficultySchema.default("normal"),
  defaultMode: z.enum(["count", "time"]).default("count"),
  defaultCount: countSchema.default(10),
  defaultDurationSeconds: durationSchema.default(180),
});

export const transkodierenRunSettingsSchema = z.object({
  range: rangeSchema,
  difficulty: difficultySchema,
  mode: z.enum(["count", "time"]),
  count: countSchema,
  durationSeconds: durationSchema,
});

// Only whole numbers and correctly grouped German thousands separators.
export function parseTranskodierenNumber(value: string): number | null {
  if (!/^(?:0|[1-9]\d{0,7}|[1-9]\d{0,2}(?:\.\d{3}){1,2})$/.test(value)) return null;
  const number = Number(value.replaceAll(".", ""));
  return number <= 99_999_999 ? number : null;
}

export const transkodierenAnswerSchema = z.object({
  type: z.literal("transkodieren"),
  itemId: z.string().min(1).max(240),
  value: z.string().max(10).refine((value) => parseTranskodierenNumber(value) !== null, "Gib eine ganze Zahl ohne Leerzeichen ein. Tausenderpunkte sind erlaubt."),
  attempt: z.union([z.literal(1), z.literal(2)]),
}).strict();

export type TranskodierenExerciseConfig = z.infer<typeof transkodierenExerciseConfigSchema>;
export type TranskodierenRunSettings = z.infer<typeof transkodierenRunSettingsSchema>;
